import {
    SectionCard,
    SectionCardH1,
    SectionCardHeading,
    SectionCardSubH1,
} from 'components/SectionCard';
import NewWatchlist from 'components/Button/NewWatchlist';
import PageBar from 'components/PageBar';
import { PagePadding } from 'components/PagePadding';
import Stack from 'components/Stack';
import WatchlistTiles from 'components/WatchlistTiles';
import { mixpanelTrack } from 'utils/app';
import { useEffect } from 'react';
import { useFetchWatchlists } from 'utils/hooks';

const space = (theme) => `${theme.space_11}px`;

function Watchlists() {
    const { data: watchlists, status } = useFetchWatchlists();

    useEffect(() => {
        mixpanelTrack('Watchlists');
    }, []);

    return (
        <PagePadding>
            <PageBar showCountrySelect={false} />
            <Stack $space={space}>
                <SectionCard>
                    <SectionCardHeading>
                        <SectionCardH1>My Watchlist.</SectionCardH1>
                        <SectionCardSubH1>
                            Quick access to your lists.
                        </SectionCardSubH1>
                        <div css="margin-left: auto">
                            <NewWatchlist />
                        </div>
                    </SectionCardHeading>
                    <WatchlistTiles.Tiles
                        tiles={
                            watchlists
                                ? Object.values(watchlists).map(
                                      ({ id, name }) => ({
                                          key: id,
                                          title: name,
                                          to: `watchlist/${id}`,
                                      }),
                                  )
                                : null
                        }
                        status={status}
                    />
                </SectionCard>
            </Stack>
        </PagePadding>
    );
}

export default Watchlists;
